export const RoutesConst = {
  home: 'home',
  login: 'login',
  logout: 'logout',
  edit: 'edit',
  add: 'add',
  forgotPassword: 'forgot-password',
  resetPassword: 'resetpassword',
  activateAccount: 'activate-account',
  myProfile: 'myprofile',
  companyProfile: 'companyprofile',
  manageUsers: 'manageusers',
  impersonation: 'impersonation',
  tutorials: 'tutorials',
  downloads: 'downloads',
  maintenance: 'maintenance',
  changePassword: 'change-password',
};
